import React from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Amplify } from "aws-amplify";
import components from "../components/AuthComponent";
import {
  Authenticator,
  useAuthenticator,
} from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import "../../assets/theme.css";

import awsExports from "../../aws-exports";
import { SHARED_ROUTES } from "../../config/routes";
//import jwt from "jsonwebtoken";
Amplify.configure(awsExports);

const Signup = () => {
  const navigate = useNavigate();

  const { user } = useAuthenticator((context) => [context.user]);
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);
  // retrieve token
  useEffect(() => {
    if (authStatus === undefined || authStatus !== "authenticated") {
      navigate("/login");
    }
    const session = user.getSignInUserSession();
    const idToken = session?.getIdToken();

    if (!idToken) {
      if (user.event === "signUp") {
        console.log("a user has signed up!");
      }
      if (user.event === "signOut") {
        console.log("a user has signed out!");
      }
    }
    navigate(SHARED_ROUTES.home);
  }, [user]);

  return (
    <>
      <Authenticator
        formFields={components.formFields}
        components={components.components}
      ></Authenticator>
    </>
  );
};

export default Signup;
